import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MARKETING_NS } from '../../i18n/marketingSegment';
import { getSegment, lastSegmentPath, type AppSegment } from '../../utils/segment';

const SEGMENTS: AppSegment[] = ['fashion', 'marketing'];

/**
 * Seletor Fashion | Marketing da barra superior. Trocar de segmento leva à
 * última tela visitada naquele segmento (ou à home dele); o segmento ativo vem
 * da URL, então o menu lateral acompanha sozinho.
 */
const SegmentSwitcher: React.FC = () => {
  const { t } = useTranslation(MARKETING_NS);
  const location = useLocation();
  const navigate = useNavigate();
  const active = getSegment(location.pathname);

  return (
    <div
      role="tablist"
      aria-label={t('switcher.label')}
      className="inline-flex items-center gap-1 p-1 rounded-xl bg-snapfy-inner border border-snapfy-border"
    >
      {SEGMENTS.map((segment) => {
        const selected = segment === active;
        return (
          <button
            key={segment}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => {
              if (!selected) navigate(lastSegmentPath(segment));
            }}
            className={`inline-flex items-center gap-2 h-8 px-3.5 rounded-lg text-[13px] transition-colors duration-150 focus-visible:outline-none focus-visible:ring-snapfy-focus ${
              selected
                ? 'bg-snapfy-surface-hover text-snapfy-text-primary font-semibold shadow-sm'
                : 'text-snapfy-text-secondary font-medium hover:text-snapfy-text-primary'
            }`}
          >
            <span
              aria-hidden
              className={`w-2 h-2 rounded-full ${selected ? 'bg-snapfy-gradient' : 'bg-snapfy-border-strong'}`}
            />
            {t(`switcher.${segment}`)}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentSwitcher;
